import React from "react";

// =====================================================================
// F-1 — agency trust stats row (ARTBOARD-SPEC board 1a item 5; wave-2
// follow-up). The artboard drew this as a DASHED PLACEHOLDER slot
// ("v2 · populated by platform"); the wave-2 brief makes it the REAL
// stats row: same layout (row, gap 36, label column min-width 150,
// value 19px/700 #0F172A over label 12px #64748B, radius 12, padding
// 13px 18px) on the real white-card chrome instead of the dashed
// placeholder border, without the amber annotation tag.
//
// Data: GET /users/agency/trust-stats (BE PR #170). Contract per the
// wave-2 brief: zeros are VALID values and still render; only an
// errored request hides the row (the page passes stats=null then).
// Board 1l (mobile agents tab) has no stats row — the page renders
// this desktop-only.
// =====================================================================
const STAT_ITEMS = [
  { key: "requests_posted", label: "Requests posted" },
  { key: "verified_players", label: "Verified players" },
  { key: "deals_closed", label: "Deals closed" },
];

const TrustStatsRow = ({ stats }) => {
  if (!stats) return null;
  return (
    <div className="px-6">
      <div
        data-testid="trust-stats-row"
        className="bg-white border border-[#E3E9F1] rounded-xl shadow-[0_1px_2px_rgba(15,23,42,.04)]"
        style={{
          marginTop: 14,
          padding: "13px 18px",
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 36,
        }}
      >
        <div style={{ minWidth: 150 }}>
          <div
            style={{
              fontSize: 11,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: ".06em",
              color: "#94A3B8",
            }}
          >
            Agency trust stats
          </div>
        </div>
        {STAT_ITEMS.map(({ key, label }) => (
          <div key={key} style={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <span
              style={{ fontSize: 19, fontWeight: 700, color: "#0F172A" }}
              data-no-translate
            >
              {Number.isFinite(Number(stats[key])) ? Number(stats[key]) : 0}
            </span>
            <span style={{ fontSize: 12, color: "#64748B" }}>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustStatsRow;
